module.exports = __webpack_public_path__ + "img/1-36-5.2ccb30dc.png";